import Experience from '../Experience.js'

// Diapositive de présentation du site, affichée pendant la descente
// d'ouverture (IntroSequence).
export default class Presentation {

    constructor() {

        this.experience = new Experience()
        this.root = document.querySelector('.presentation')
        this.template = document.getElementById('presentation-card-template')?.innerHTML ?? ''
        this.data = this.experience.resources.items.presentation?.intro

        this.visible = false
        this.currentOpacity = 0

        this.setDOM()
    }

    setDOM() {

        if (!this.root || !this.data) return

        this.inner = document.createElement('div')
        this.inner.className = 'presentation__inner'
        this.inner.innerHTML = this.template.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => this.data[key] ?? '')
        this.root.appendChild(this.inner)
        this.root.style.opacity = 0
    }

    setVisible(visible) {
        this.visible = visible
    }

    update() {

        if (!this.root) return

        this.currentOpacity += ((this.visible ? 1 : 0) - this.currentOpacity) * 0.08

        this.root.style.opacity = this.currentOpacity
        this.root.style.transform = `translateY(${12 * (1 - this.currentOpacity)}px)`
    }

    destroy() {

        if (this.root) {
            this.root.innerHTML = ''
        }
    }
}
